interface TokenData {
  iss: string
  iat: number
  exp: number
  sub: number
  jti: string
  sid: string
  authenticated_at: string
  user: {
    impersonate: boolean
    team_id: string
  }
  teams?: Record<string, {
    privileges: Record<string, { allowed: boolean }>
  }>
};
const extractDataFromToken = (token: string): TokenData | null => {
  if (!token || typeof token !== 'string') return null
  try {
    return JSON.parse(atob(token.split('.')[1] ?? ''))
  }
  catch (error) {
    throw new Error(`Failed to parse token: ${error}`)
  }
}
const getTeamFromToken = (token: string): string => {
  const tokenData = extractDataFromToken(token)
  if (!tokenData || !tokenData.user || !tokenData.user.team_id) {
    throw new Error('Invalid token data: missing team_id')
  }
  return tokenData.user.team_id
}

const getUserIdFromToken = (token: string): string => {
  const tokenData = extractDataFromToken(token)
  return tokenData?.sub ? String(tokenData.sub).split(':')[1]! : ''
}

const shouldImpersonate = (token: string): boolean => {
  const tokenData = extractDataFromToken(token)
  return !!(tokenData && tokenData.user?.impersonate && tokenData.user?.team_id)
}

export {
  shouldImpersonate,
  extractDataFromToken,
  getTeamFromToken,
  getUserIdFromToken,
}
